module.exports = __webpack_public_path__ + "img/logo-slim.ae8fc4e2.png";